import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { InlinePanelLayout } from "abreact/expression/layout/InlinePanelLayout";
import { ArgumentOperandValueEditor, ArgumentOperandValueEditorWithManagedFocus } from "abreact/expression/ui/editor/impl/condition/operandValue/operand/argument/ArgumentOperandValueEditor";
import { OptionalArgumentManager } from "abreact/expression/ui/editor/impl/condition/operandValue/operand/argument/OptionalArgumentManager";
import { GuidedExpressionEditorUtils } from "abreact/expression/ui/editor/impl/utils/GuidedExpressionEditorUtils";
import { AbGenericFocusManagerContext } from "abreact/incubator/ui/abBooleanLogicTree/AbGenericFocusManager";
import * as React from "react";
import { useContext } from "react";

/**
 * Displays the argument operands of an operator, with controls for showing and hiding optional arguments.
 * NOTE: Do not confuse this with an ExpArgumentOperandGroup - they are different concepts.
 */
export function ArgumentOperandValueEditorGroup(props) {
  const {
    sourceOperandValue,
    operatorOperandValue
  } = props;
  const optionalContext = React.useContext(OptionalArgumentManager.Context);
  const focusManagerContext = useContext(AbGenericFocusManagerContext);
  const argumentOperandValueViews = [];
  for (const argumentOperand of props.argumentOperands) {
    if (!props.isAdvanced && argumentOperand.isOptional && !optionalContext.shownOptionalArgumentIdentifiers.has(argumentOperand.argumentIdentifier) && argumentOperand.elementInfos.length > 0) {
      continue;
    }
    const operandValue = GuidedExpressionEditorUtils.findArgumentOperandValue(argumentOperand, props.operandValuesByOperandName);
    const baseProps = {
      sourceOperandValue: sourceOperandValue,
      operatorOperandValue: operatorOperandValue,
      argumentOperandValuesByOperandName: props.operandValuesByOperandName,
      operandValue: operandValue,
      argumentOperand: argumentOperand,
      liveViewSliceModel: props.liveViewSliceModel,
      expressionDomainModel: props.expressionDomainModel,
      componentFactory: props.componentFactory,
      dataTestId: props.dataTestId,
      generateId: props.generateId,
      rowKey: props.rowKey
    };
    const ArgumentEditor = focusManagerContext == null ? ArgumentOperandValueEditor : ArgumentOperandValueEditorWithManagedFocus;

    // See if we have any unmet dependencies.
    let contents;
    const key = ArgumentOperandValueEditor.createKey(argumentOperand);
    if (props.isReadonly || operandValue?.isEditable === false) {
      contents = /*#__PURE__*/React.createElement(ArgumentEditor, _extends({
        key: key,
        isReadonly: true
      }, baseProps));
    } else {
      contents = /*#__PURE__*/React.createElement(ArgumentEditor, _extends({
        key: key,
        isReadonly: false
      }, baseProps, {
        customizationFunctions: props.customizationFunctions,
        applyOperandValue: props.applyOperandValue
      }));
    }
    argumentOperandValueViews.push(/*#__PURE__*/React.createElement(InlinePanelLayout.Item, {
      key: key,
      className: "ab-gee-operand-value-editor-container"
    }, contents));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, argumentOperandValueViews);
}
//# sourceMappingURL=ArgumentOperandValueEditorGroup.js.map
